
import Navigation from './components/navigation';
import image from './components/image';
import Timeline from './components/timeline';
import Accordion from './components/accordion';
import EquipeRanking from './components/equipe-ranking';
import InputField from './components/input-field';
import SearchForm from './components/search-form';
import RegisterForm from './components/register-form';
import WallOfFame from './components/wall-of-fame';
import Hero from './components/hero';
import LovstaWorld from './components/lovsta-world';
import CollapsedList from './components/collapsed-list';

function init() {
  Navigation();
  Timeline();
  Accordion();
  WallOfFame();
  image('.image img');
  EquipeRanking();
  InputField();
  SearchForm();
  RegisterForm();
  Hero();
  LovstaWorld();
  CollapsedList();
}

document.addEventListener('DOMContentLoaded',() => init());

